// removed by extract-text-webpack-plugin
module.exports = {"header":"header__MJiDp","go-to-shop-desktop":"go-to-shop-desktop__klxZT","no-background":"no-background__ilvKZ","top-bar":"top-bar__18gTj","light":"light__336d1","dark":"dark__1bsbE","separator":"separator__2KygT","links":"links__cp9gf"};


//////////////////
// WEBPACK FOOTER
// ./components/header/desktop/DesktopHeader.scss
// module id = rdLW
// module chunks = 1